import { combineReducers } from '@ngrx/store';

import {
    EDU_COURSES_COLLECTIONS_FEATURE_KEY,
    eduCoursesCollectionReducer,
    type EduCoursesCollectionState,
} from './edu-courses/edu-courses.reducer';
import {
    EDU_COURSE_PAYMENTS_COLLECTION_FEATURE_KEY,
    eduCoursePaymentsCollectionReducer,
    type EduCoursePaymentsCollectionState,
} from './edu-course-payments/edu-course-payments.reducer';
import {
    TESTIMONIALS_COLLECTION_FEATURE_KEY,
    testimonialsCollectionReducer,
    type TestimonialsCollectionState,
} from './testimonials/testimonials.reducer';
import { SITES_COLLECTION_FEATURE_KEY, sitesCollectionReducer, type SitesCollectionState } from './sites/sites.reducer';
import {
    CHAT_BOTS_COLLECTION_FEATURE_KEY,
    chatBotsCollectionReducer,
    type ChatBotsCollectionState,
} from './chat-bots/chat-bots.reducer';
import {
    CHAT_BOT_CHAINS_COLLECTION_FEATURE_KEY,
    chatBotChainsCollectionReducer,
    type ChatBotChainsCollectionState,
} from './chat-bot-chains/chat-bot-chains.reducer';
import {
    EDU_SCHOOLS_COLLECTIONS_FEATURE_KEY,
    eduSchoolsCollectionReducer,
    type EduSchoolsCollectionState,
} from './edu-schools/edu-schools.reducer';
import {
    EDU_COURSES_TARIFFS_COLLECTION_FEATURE_KEY,
    eduCoursesTariffsCollectionReducer,
    type EduCoursesTariffsCollectionState,
} from './edu-courses-tariffs/edu-courses-tariffs.reducer';

export type CollectionsState = {
    [EDU_COURSES_COLLECTIONS_FEATURE_KEY]: EduCoursesCollectionState;
    [EDU_COURSE_PAYMENTS_COLLECTION_FEATURE_KEY]: EduCoursePaymentsCollectionState;
    [TESTIMONIALS_COLLECTION_FEATURE_KEY]: TestimonialsCollectionState;
    [SITES_COLLECTION_FEATURE_KEY]: SitesCollectionState;
    [CHAT_BOTS_COLLECTION_FEATURE_KEY]: ChatBotsCollectionState;
    [CHAT_BOT_CHAINS_COLLECTION_FEATURE_KEY]: ChatBotChainsCollectionState;
    [EDU_SCHOOLS_COLLECTIONS_FEATURE_KEY]: EduSchoolsCollectionState;
    [EDU_COURSES_TARIFFS_COLLECTION_FEATURE_KEY]: EduCoursesTariffsCollectionState;
};

export const COLLECTIONS_FEATURE_KEY = 'collections';

export const collectionsReducer = combineReducers<CollectionsState>({
    [EDU_COURSES_COLLECTIONS_FEATURE_KEY]: eduCoursesCollectionReducer,
    [EDU_COURSE_PAYMENTS_COLLECTION_FEATURE_KEY]: eduCoursePaymentsCollectionReducer,
    [TESTIMONIALS_COLLECTION_FEATURE_KEY]: testimonialsCollectionReducer,
    [SITES_COLLECTION_FEATURE_KEY]: sitesCollectionReducer,
    [CHAT_BOTS_COLLECTION_FEATURE_KEY]: chatBotsCollectionReducer,
    [CHAT_BOT_CHAINS_COLLECTION_FEATURE_KEY]: chatBotChainsCollectionReducer,
    [EDU_SCHOOLS_COLLECTIONS_FEATURE_KEY]: eduSchoolsCollectionReducer,
    [EDU_COURSES_TARIFFS_COLLECTION_FEATURE_KEY]: eduCoursesTariffsCollectionReducer,
});
